import React, { forwardRef, useRef } from 'react'
import { Link } from 'react-router-dom';
import { useDropdownFilter } from '../Custom_Hooks/useDropdownFilter';
import { useDropdownKeyboardNavigation } from '../Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../Custom_Hooks/useDropdownScroll';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from '../../redux/actions/action-creator';
import { useDropdownPosition } from '../Custom_Hooks/useDropdownPosition';


const DropdownForItemLedgerDynamic = forwardRef((
    { title,
        state,
        input_value,
        input_key,
        input_id,
        input_blc,
        rawData,
        data,
        setData,
        setSubmitConfirm,
        inputRefs,
        index,
        modal_id,
        refs,
        narr_ref,
        handleDropdownClick,
        rowId,
        loading
    }, ref) => {

    const dropdownRef = useRef(null)
    const dispatch = useDispatch();
    const coords = useDropdownPosition(state, ref);
    let is_dropdown_clicked = false;
    const { filteredData } = useDropdownFilter({
        dataList: rawData,
        searchInput: input_value,
        inputRef: ref,
    });

    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: filteredData,
        state,
        onItemSelect: (item) => {
            is_dropdown_clicked = true;
            const new_data = data?.data?.filter((item1) => {
                return String(item1.particular_ledger_id !== '' && item1.particular_ledger_id !== null && item1.particular_ledger_id) === String(item.id);
            });
            let get_amount

            if (new_data.length > 0) {
                const amount = new_data.slice(-1).map((item, index) => { return (item.particular_ledger_balance) })
                get_amount = amount[0]
            } else {
                get_amount = item?.opening_balance
            }

            setData((prevData) => {

                const updatedData = { ...prevData };
                if (typeof index !== "number") {
                    updatedData[input_key] = item?.ledger_name || item?.name || item?.symbol;
                } else if (typeof index === "number") {
                    updatedData.sale_ledger_data = updatedData.sale_ledger_data.map((item_data, i) =>
                    {
                        const isMatch = rowId ? item_data.id === rowId : i === index;
                        if(item?.ledger_name==='End of List'){
                            return(
                                isMatch ? {
                                    ...item_data,
                                    [input_key]: '',
                                    [input_id]: ''
                                } : item_data
                            )
                        }
                        return(
                        isMatch ? {
                            ...item_data,
                            [input_key]: item?.ledger_name||item?.name||item?.symbol,
                            [input_id]: item?.id || '',
                            [input_blc]: get_amount || ''
                        } : item_data
                    )
                    })

                }
                return updatedData;
            });
            dispatch(closeModal(`${input_key}${modal_id || rowId || index}`))
            if (handleDropdownClick) {
                handleDropdownClick(input_key, item?.ledger_name || item?.name || item?.symbol, rowId || index);
            }
        },
        onItemAltCSelect: () => {
            // Close the current dropdown and open ledger creation modal
            dispatch(closeModal(`${input_key}${modal_id || index}`));
            dispatch(openModal("ledgerCreate"));
        },
        input_value,
    });

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    return (
        <div 
            className={`dropdown-content-list ${state ? 'show-list' : ''}`}
            style={{
                ...coords,
                display: state ? 'flex' : 'none',
                flexDirection: 'column',
                overflow: 'hidden',
                padding: 0
            }}
        >
            <div className='col' style={{ background: 'skyblue', position: 'sticky', top: 0, flexShrink: 0 }}>
                {title}
            </div>

            <div id='data' ref={dropdownRef} style={{ overflowY: 'auto', flex: 1 }}>
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center p-3">
                        <i className="fas fa-spinner fa-spin me-2"></i>
                        <span>Loading...</span>
                    </div>
                ) : Array.isArray(filteredData) && filteredData?.map((key, number) => {
                        const name = key?.ledger_name || key?.name || key?.symbol;
                        const formal_name = key?.formal_name
                        const type = key?.type
                        const balance = key?.opening_balance;
                        const id = key?.id;
                        const index_1 = name?.toLowerCase()?.indexOf(input_value?.toLowerCase());
                        return (
                            <Link
                                className={`list  ${number === selectedItemIndex ? 'selected' : ''}`}
                                id='list'
                                key={number}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedItemIndex(number);
                                    if (number === selectedItemIndex) {
                                        // Get selected item data
                                        const selectedItem = filteredData[number];
                                        is_dropdown_clicked = true;
                                        // Calculate amount based on existing data or opening balance
                                        const new_data = data?.data?.filter(item1 =>
                                            String(item1.particular_ledger_id) === String(selectedItem.id)
                                        );

                                        const get_amount = new_data.length > 0
                                            ? new_data[new_data.length - 1].particular_ledger_balance
                                            : selectedItem?.opening_balance;

                                        // Update data state
                                        setData(prevData => {
                                            const updatedData = { ...prevData };

                                            if (typeof index !== "number") {
                                                updatedData[input_key] = selectedItem?.ledger_name || selectedItem?.name || selectedItem?.symbol;
                                            } else {
                                                updatedData.data = updatedData.data.map((item_data, i) =>
                                                    (rowId ? item_data.id === rowId : i === index) ? {
                                                        ...item_data,
                                                        [input_key]: selectedItem?.ledger_name,
                                                        [input_id]: selectedItem?.id || '',
                                                        [input_blc]: get_amount || ''
                                                    } : item_data
                                                );
                                            }
                                            return updatedData;
                                        });

                                        // Handle focus management
                                        const fields = Object.keys(refs?.current);
                                        const targetRowRefKey = rowId || index;
                                        const currentIndex = fields.indexOf(`${input_key}${targetRowRefKey}`);

                                        if (selectedItem?.ledger_name === 'End of List') {
                                            narr_ref?.narration?.current?.focus();
                                            narr_ref?.narration?.current?.setSelectionRange(0, narr_ref?.narration?.current?.value?.length || 0);
                                        } else if (currentIndex < fields.length - 1) {
                                            const nextField = fields[currentIndex + 1];
                                            const nextRef = refs?.current[nextField];
                                            if (nextRef) {
                                                nextRef.focus();
                                                nextRef.setSelectionRange(0, nextRef.value?.length || 0);
                                            }
                                        }
                                        if (handleDropdownClick) {
                                            handleDropdownClick(input_key, selectedItem?.ledger_name || selectedItem?.name || selectedItem?.symbol, rowId || index);
                                        }

                                        dispatch(closeModal(`${input_key}${modal_id || rowId || index}`));
                                    }
                                }}
                            >
                                <div className='row m-0'>
                                    <div className={formal_name ? 'col-6 p-0' : 'col-12 p-0'}>
                                        {index_1 !== -1 ? (
                                            < >
                                                {name?.substring(0, index_1)}
                                                <span style={{ color: 'red' }}>{name?.substring(index_1, index_1 + input_value?.length)}</span>
                                                {name?.substring(index_1 + input_value?.length)}
                                            </>
                                        ) : (
                                            name
                                        )}

                                    </div>
                                    {
                                        formal_name ?
                                            <div className='col-6'>
                                                {formal_name && type === 'Simple' ? `(${formal_name})` : null}
                                            </div> : null
                                    }
                                </div>
                            </Link>
                        );
                    })
                }

            </div>
        </div>
    )
})

export default React.memo(DropdownForItemLedgerDynamic)
